export default __webpack_public_path__ + "static/media/model_queue.88a93b39.png";